export default __webpack_public_path__ + "static/card-3-2e54def770afb76091343915bdaa6b94.png";